import AssetList from "../../slices/assets/asset/AssetList";
import AssetDetails from "../../slices/assets/asset/AssetDetails";
import AssetByCategory from "../../slices/assets/asset/AssetByCategory";
import AssetIssueByItem from "../../slices/assets/asset_issue/AssetIssueByItem";
import AssetIssueList from "../../slices/assets/asset_issue/AssetIssueList";
import AssetIssueDetails from "../../slices/assets/asset_issue/AssetIssueDetails";
import ToolsPartsTransferList from "../../slices/assets/tools_parts_transfer/ToolsPartsTransferList";
import ToolsPartsTransferDetails from "../../slices/assets/tools_parts_transfer/ToolsPartsTransferDetails";
import ToolsPartsInventory from "../../slices/assets/tools_parts_transfer/ToolsPartsInventory";
import ToolsPartsReturnList from "../../slices/assets/tools_parts_return/ToolsPartsReturnList";
import ToolsPartsIssued from "../../slices/assets/tools_parts_return/ToolsPartsIssued";
import AssetNotes from "../../slices/assets/assets_location/AssetNotesList";
import MaintenanceByAssetDetails from "../../slices/assets/assets_location/MaintenanceByAssetDetails";
import InstructionDetails from "../../slices/assets/modal/InstructionList";
import AssetDetailsByFilter from "../../slices/assets/inventory/AssetDetailsByFilter";
import UpdateAssetSerialNumbers from "../../slices/assets/inventory/UpdateAssetSerialNumbers";
import StockList from "../../slices/stock/StockList";
import StockDetails from "../../slices/stock/StockDetails";
import InstructionList from "../../slices/assets/modal/InstructionList";
import GrnList from "../../slices/grn/GRNList";
import GrnDetails from "../../slices/grn/GRNDetails";
import AmcList from "../../slices/assets/amc/AmcList";
import AmcDetails from "../../slices/assets/amc/AmcDetails";
import AssetItemByLocation from "../../slices/assets/asset/AssetByLocation";

const assetReducer = {
    assetList: AssetList,
    assetDetails: AssetDetails,
    assetByCategory: AssetByCategory,
    assetIssueByItem: AssetIssueByItem,
    assetIssueList: AssetIssueList,
    assetIssueDetails: AssetIssueDetails,
    toolsPartsTransferList: ToolsPartsTransferList,
    toolsPartsTransferDetails: ToolsPartsTransferDetails,
    toolsPartsInventory: ToolsPartsInventory,
    toolsPartsReturnList: ToolsPartsReturnList,
    toolsPartsIssued: ToolsPartsIssued,
    assetNotes: AssetNotes,
    maintenanceByAssetDetails: MaintenanceByAssetDetails,
    instructionDetails: InstructionDetails,
    assetDetailsByFilter: AssetDetailsByFilter,
    updateAssetSerialNumbers: UpdateAssetSerialNumbers,
    stockList: StockList,
    stockDetails: StockDetails,
    instructionList: InstructionList,
    grnList: GrnList,
    grnDetails: GrnDetails,
    amcList: AmcList,
    amcDetails: AmcDetails,
    assetItemByLocation: AssetItemByLocation,
};

export default assetReducer;